import request from "@/utils/request";

export function ApiGetUserInfo() {
  return request({
    url: `/fenydata-java-console/api/0/v1/getUserInfo`,
    method: 'post',
  });
}
